// extracted by mini-css-extract-plugin
module.exports = {"container":"backButton-module--container--1lqTg","icon":"backButton-module--icon--UKF5K","button":"backButton-module--button--3PPyM","text":"backButton-module--text--1XBs4"};